import type {ConnectElementConfig} from '../ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const BusinessProfileManagementConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "businessProfileManagement" */
      '../../../components/BusinessProfileManagement/BusinessProfileManagement'
    ),
  enabledOverrideFlag: ComponentOverrideFlag.business_profile_management,
  htmlEvents: ['onbusinessprofilesaved'],
  customHtmlElementMethods: {
    setOnBusinessProfileSaved: {
      type: 'EventListenerMethod',
      event: 'onbusinessprofilesaved',
      isInternal: false,
      description:
        'Sets a callback that runs after a business profile is created or updated.',
    },
  },
  releaseState: 'internal',
  requiresAuthentication: true,
  sentryTeam: 'connect_marketplaces',
  teamOwner: 'connect-integrations',
  description:
    'Allows connected accounts to create or edit their business profile',
  friendlyName: 'Business profile management',
};
